import React from 'react';
import { Target, ChevronRight } from 'lucide-react';

const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
const num = (v, c = 1) => new Intl.NumberFormat('pt-BR', { minimumFractionDigits: c, maximumFractionDigits: c }).format(v || 0);

const DashboardMeta = ({ stats, metaGlobal, isAdmin, onNavigate }) => {
  const porcentagemMeta = metaGlobal > 0 ? (stats.tonelagem_faturada / metaGlobal) * 100 : 0;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-400">Meta Mensal</p>
          <p className="text-sm font-black text-slate-800 mt-0.5">Tonelagem Faturada</p>
        </div>
        <Target size={20} className="text-slate-300" />
      </div>
      <div className="flex justify-between items-end mb-2">
        <div>
          <span className="text-3xl font-black text-[#0A3D73]">{num(stats.tonelagem_faturada)}</span>
          <span className="text-xs font-bold text-slate-400 ml-1">/ {num(metaGlobal)} TON</span>
        </div>
        <span className={`text-lg font-black ${porcentagemMeta >= 100 ? 'text-green-600' : 'text-[#0A3D73]'}`}>
          {num(porcentagemMeta)}%
        </span>
      </div>
      <div className="w-full bg-slate-100 h-2.5 rounded-full overflow-hidden">
        <div className={`h-full transition-all duration-1000 rounded-full ${porcentagemMeta >= 100 ? 'bg-green-500' : 'bg-[#0A3D73]'}`}
          style={{ width: `${Math.min(porcentagemMeta, 100)}%` }} />
      </div>
      <div className="flex justify-between mt-2">
        <p className="text-xs text-slate-400">{num(stats.tonelagem_faturada, 3)} TON faturadas</p>
        <p className="text-xs text-slate-400">Meta: {num(metaGlobal)} TON</p>
      </div>
      <div className="mt-4 pt-3 border-t border-slate-100 space-y-2">
        <div className="flex justify-between text-xs">
          <span className="text-slate-400 font-semibold">Carteira implantada</span>
          <span className="font-black text-slate-700">{num(stats.tonelagem_implantada, 3)} TON</span>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-slate-400 font-semibold">Comissão prevista</span>
          <span className="font-black text-slate-700">{brl(stats.comissao_prevista)}</span>
        </div>
      </div>
      {isAdmin && (
        <button onClick={() => onNavigate('/metas')}
          className="mt-4 w-full py-2 bg-slate-50 hover:bg-[#0A3D73] hover:text-white transition-all text-xs font-black rounded-lg border border-slate-200 flex items-center justify-center gap-1.5">
          Ver metas por cliente <ChevronRight size={12} />
        </button>
      )}
    </div>
  );
};

export default DashboardMeta;
